<template>
	<div class="table">
		<div class="table-head">
			<div class="info w-3">
				商品信息
			</div>
			<div class="info w-3">
				报价详情
			</div>
			<div class="w-1">
				短信通知状态
			</div>
			<div class="info w-2">
				经销商反馈状态
			</div>
			<div class="w-1">
				操作
			</div>
		</div>
		<div class="wrap">
			<div class="table-content" v-for="(item,index) in items" :key="item.id + 'h' + index">
				<div class="content-img w-3">
					<div class="">
	                	<!--<a class="img-wrap" href="javascript:;" target="_blank"
					       v-lazy:background-image="item.imgUrl">
					    </a>-->
					    <a class="img-wrapp" href="javascript:;" target="_blank"
					       v-lazy:background-image="item.imgUrl">
					       <img
		                    	v-if="item.imgUrl"
		                    	:src="item.imgUrl"
		                    	:preview="index + '_' + item.id"
		                  	>
					    </a>
	                </div>
	                <div class="info">
	                  <p class="name tx-ellipsis2 ">
	                    <span>商品名称：</span>{{item.name}}
	                  </p>
	                  <p class="name tx-ellipsis2 ">
	                    <span>经销商30天销量：</span>{{item.sold30Days}} 件
	                  </p>
					  <p class="name tx-ellipsis2 ">
					    <span>商品属性：</span>{{item.property}}
					  </p>
	                </div>
				</div>
				<div class="content-info w-3">
		            <p class="name">报价时间：
		                <span>{{item.timeOffered}}</span>
		            </p>
		            <p class="name">报价：
		                <span>￥ {{parseFloat(item.price).toFixed(2)}}</span>
		            </p>
		            <p class="name tx-primary tx-ellipsis2">采购链接：
		                <a href="javascript:;" :href="item.skuUrl" target="_blank">{{item.skuUrl}}</a>
		            </p>
		            <p class="name tx-ellipsis2" v-if="item.remark">供应商备注：
		                <span>{{item.remark}}</span>
		            </p>
				</div>
				<div class="content-info w-1">
					<p :class="item.noticeStatus | showNoticeStatus">{{item.noticeStatus == 1?"已通知经销商":"未通知经销商"}}</p>
					<p class="name">{{item.timeNoticed}}</p>
				</div>
				<div class="content-info w-2">
					<p :class="item.feedbackStatus | feedbackStatusStyle">{{feedbackStatus[item.feedbackStatus]}}</p>
					<p v-if="item.reason > 0">经销商标记为：<span class="tx-warning">{{item.reason == 1?"价格太贵":"不是同款"}}</span></p>
				</div>
				<div class="content-btn w-1">
					<a
	                data-type="btn" 
	                class="btn btn-primary" 
	                href="javascript:;" 
	                @click="offerAgain(item.id)"
	              	>重新报价</a>
				</div>
			</div>
		</div>
		<div class="page-bottom" v-show="!showLogin">
			<p>您还没有登录，请先
				<a href="javascript:;" @click="openRegModal('1')">登录</a>
			</p>
		</div>
		<div class="page-bottom" v-show="showLogin && items.length == 0">
			<p>您还没有提交任何报价，<router-link :to="{ path: '/' }">快去看看</router-link>有哪些热卖商品可以报价吧</p>
		</div>
		<div class="page-bottom" v-show="last && items.length > 0 && total > 1">
			<p>已经是最后一页了</p>
		</div>
	</div>
</template>

<script>
import bgimg from './../assets/img/none-img.png'

export default {
  props:["items","last","total"],
  data(){
    return {
    	showLogin: localStorage.getItem("supplierPriceInfo")?true:false,
    	feedbackStatus: {
	        1: '未查看',
	        2: '已查看报价还未打开采购链接',
	        3: '已打开采购链接',
	        4: '已查看',
    	},
      	bgimg,
    }
  },
  filters: {
  	feedbackStatusStyle(val){
  		val = val - 0;
      let style = '';
      switch(val){
        case 1:
          style = 'tx-danger'
          break;
        case 2:
          style = 'tx-warning'
          break;
        case 3:
          style = 'tx-success'
          break;
        case 4:
          style = 'tx-success'
          break;
      }
      return style;
    },
    showNoticeStatus(val){
      if(val == 1){
        return 'tx-success'
      }else{
        return 'tx-danger'
      }
    },
  },
  methods:{
  	offerAgain(id){
    	this.$emit("offerAgain",id);
   },
   openRegModal(type){
  		this.$emit("openRegModal",type);
  	},
  }
};
</script>

<style lang="less" scoped>
@import "./../assets/style/config.less";
.table {
	min-width: 38rem;
  	margin: 1.25rem auto;
  	padding: 0;
  	margin-bottom: 80px;
    border-spacing: 0;
    border-collapse: collapse;
    vertical-align: middle;
    width: 100%;
    border: 1px solid @b-c-gray;
    color: @black-1;
    font-size: 14px;
    >.table-head{
    	width: 100%;
      	display: flex;
      	align-items: center;
      	>div{
      		border-top: 0;
    		border-bottom: 1px solid #dee2e6;
   	 		padding: 0 10px;
    		height: 32px;
    		line-height: 32px;
    		font-weight: bold;
      	}
      	>.w-3 {
          flex-grow: 3;
          max-width: 30%;
      	  width: 30%;
        }
        >.w-2 {
          flex-grow: 2;
          max-width: 20%;
      	  width: 20%;
        }
        >.w-1 {
          flex-grow: 1;
          max-width: 10%;
      	  width: 10%;
        }
    }
    >.wrap{
    	.table-content{
	    	width: 100%;
	      	display: flex;
	      	align-items: center;
	      	border-bottom: 1px solid #dee2e6;
	      	>div{
	      		padding: 5px 10px;
	      	}
	      	>.content-img{
	      		display: flex;
	            align-items: center;
	            .img-wrapp {
	              margin-right: 15px;
	            }
	            .img-wrapp {
				  display: block;
				  position: relative;
				  min-width: 80px;
				  min-height: 80px;
				  width: 80px;
				  height: 80px;
				  border: 1px solid @b-c-gray;
				  background-color: @white;
				  background-size: 100%;
				  background-position: center;
				  background-repeat: no-repeat;
				  > img{
				    display: none;
				    position: absolute;
				    top: 0;
				    right: 0;
				    bottom: 0;
				    left: 0;
				    opacity: 0;
				    width: 80px;
				    height: 80px;
				    cursor: pointer;
				  }
				}
				.img-wrapp.lazyload-success img{
				  display: block;
				}
				
				.img-wrapp.bg-y-100 {
				  background-size: auto 100% !important;
				}
	            .info {
	              p {
	                margin: 0 0 10px;
	              }
	              .name {
	                word-break: break-all;
	                color: #333;
	    			font-size: 14px;
	                span {
	                  color: @gray-1;
	                }
	              }
	              > a {
	                color: @primary;
	              }
	            }
	      	}
	      	>.content-info{
	      		>p{
	      			color: #333;
	    			font-size: 14px;
	    			margin: 0 0 5px;
	      			>input{
	      				height: 1.5rem;
					    border: 0.0625rem #c1c1c1 solid;
					    padding: 0 0.5rem;
					    text-align: left;
					    background-color: #fff;
	      			}
	      			>span {
	      				font-size: 12px;
	                  	color: @gray-1;
	                }
	      		}
	      		>.name{
	      			>input{
	      				margin-left: 24px;
	      			}
	      		}
	      		>.address{
	      			>input{
	      				margin-left: 10px;
	      				width: 60%;
	      			}
	      		}
	      		>.remark{
	      			>input{
	      				width: 60%;
	      			}
	      		}
	      		>p:last-child{
	      			margin-bottom: 0;
	      		}
	      		>.tx-success{
	      			color: @success;
	      		}
	      		>.tx-primary{
	      			a{
	      				color: @primary;
	      			}
	      		}
	      	}
	      	>.w-3 {
	          	flex-grow: 3;
	          	max-width: 30%;
	      	  	width: 30%;
	        }
	        >.w-2 {
	          	flex-grow: 2;
	          	max-width: 20%;
	      	  	width: 20%;
	        }
	        >.w-1 {
	          	flex-grow: 1;
	          	max-width: 10%;
	      	  	width: 10%;
	        }
	    }
	    .table-content:hover {
        	background-color: @table-bg;
      	}
    }
    >.page-bottom{
    	p{
    		margin: 1.25rem 0;
    		text-align: center;
    		color: #999;
    		font-size: 16px;
    		a{
    			color: @primary;
    			text-decoration: underline;
    		}
    	}
    }
  }
@media (min-width: 700px) {
  .table {
    max-width: 38rem;
  }
}
@media (min-width: 970px) {
  .table {
    max-width: 57rem;
  }
}
@media (min-width: 1270px) {
  .table {
    max-width: 76rem;
  }
}
@media (min-width: 1870px) {
  .table {
    max-width: 114rem;
  }
}
</style>

